import { Text } from "@/base/index";
import { useFooterNavigateStyles } from "./footer-navigate.styles";

export const FooterNavigateCopyright = () => {
  const { styles } = useFooterNavigateStyles();

  return (
    <div className={styles.copyright}>
      <Text>
        Copyright © 2002-2025. All Rights Reserved. Petrosoft LLC, 290 Bilmar
        Drive, Pittsburgh, PA
      </Text>
    </div>
  );
};
